module.exports = __webpack_public_path__ + "media/img/logos/2023/schnurrbart-5fd8a4324ea4e9bd5daccccb2eaef4f9.svg";